// usage-cols.jsx — column defs for the two "Where used" grids, shared by
// ProductsView's own Where-used cards and components/UsageCards.jsx (the
// per-placement version on the Function screen). Extracted 2026-08-20 so a
// second "where is this used" surface doesn't retype the same two column sets.

import { NAVY } from './theme-tokens.js';

// "Used in Products" — parent products that reference this product as a
// sub-component (usage.components, product_comps.kind='product').
// Read-only (no onSave/onAdd/onDelete/onReorder passed to DataGrid).
export const USED_IN_PRODUCTS_COLS = [
  {
    key: 'code', label: 'Code', width: 130,
    render: row => <span style={{ fontFamily: 'var(--ff-mono)', fontSize: 'var(--fs-mono)', fontWeight: 600, color: NAVY }}>{row.code || '—'}</span>,
  },
  { key: 'label', label: 'Label', width: 260, render: row => row.label || '(no label)' },
];

// "Placed in Projects" — this product placed inside a project function
// (usage.placements).
export const PLACED_IN_PROJECTS_COLS = [
  {
    key: 'project_code', label: 'Project', width: 110,
    render: row => <span style={{ fontFamily: 'var(--ff-mono)', fontSize: 'var(--fs-mono)', fontWeight: 600, color: NAVY }}>{row.project_code || '—'}</span>,
  },
  { key: 'function_path', label: 'Function', width: 260, render: row => row.function_path || '—' },
  { key: 'label', label: 'Label', width: 180, render: row => row.label || '(no label)' },
];
